import React, { useState } from "react";
import { Box, Container, Tab, Grid, Button } from "@mui/material";
import BookCard from "../../../components/cards/BookCard";
import { StyledTabs } from "../../../components/home-tab/HomeTab";
import { SectionTitle } from "../../../components/home-section-title/HomeSectionTitle";
import useBestSellers from "../../../hooks/api-request/useBestSellers";
import BestSellersSkeleton from "../../../components/skeletons/BestSellersSkeleton";
import { useNavigate } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EmptyState from "../../../components/no-data/NoData";
import { useTranslation } from "react-i18next";

const BestSellers = () => {
  const [currentTab, setCurrentTab] = useState(0);
  const { data: books, isLoading } = useBestSellers();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  
  // Check if the current language is RTL
  const isRtl = i18n.language === 'ps' || i18n.language === 'dr';
  
  // Choose arrow icon based on direction
  const DirectionalArrowIcon = isRtl ? ArrowBackIcon : ArrowForwardIcon;

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  // Filter books based on format
  const filteredBooks =
    books?.filter((book) =>
      currentTab === 0 ? book.format === "PDF" : book.format === "Audiobook",
    ) || [];

  if (isLoading) {
    return <BestSellersSkeleton />;
  }

  return (
    <Box sx={{ py: 6, backgroundColor: "#fff" }}>
      <Container maxWidth="xl">
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
          }}
        >
          <SectionTitle variant="h2">{t('home.bestSellers.title')}</SectionTitle>
          <Button
            endIcon={<DirectionalArrowIcon />}
            onClick={() => navigate("/books")}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              "&:hover": {
                backgroundColor: "transparent",
                opacity: 0.8,
              },
            }}
          >
            {t('home.viewAllBooks')}
          </Button>
        </Box>

        <StyledTabs
          value={currentTab}
          onChange={handleTabChange}
          aria-label="product categories"
        >
          <Tab label={t('home.formats.books')} />
          <Tab label={t('home.formats.audiobooks')} />
        </StyledTabs>

        {filteredBooks.length > 0 ? (
          <Grid container spacing={2.5}>
            {filteredBooks.slice(0, 5).map((book) => (
              <Grid item xs={6} sm={6} md={2.4} key={book.id}>
                <BookCard book={book} />
              </Grid>
            ))}
          </Grid>
        ) : (
          <EmptyState />
        )}
      </Container>
    </Box>
  );
};

export default BestSellers;
